import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const WaypointIconsPropTypes = {
  glyph: PropTypes.string.isRequired, // Icon to display beside the input field
  last: PropTypes.bool, // If this is the last rendered component in a list of input fields
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have successfully returned from API
};

const WaypointDefaultProps = {
  last: true,
};

// eslint-disable-next-line arrow-parens
const WaypointIcons = props => {
  // eslint-disable-next-line object-curly-newline
  const { glyph, last, isMobile, directionsLoaded } = props;

  const glyphIcon = glyph ? (
    <i className={classNames(`tsla-icon-${glyph}`)} />
  ) : null;
  const mapPin = <i className="tsla-icon_map--pin" />;
  const waypointDots = <i className="tsla-icon-ellipsis-v" />;
  const grabber = <i className="tsla-icon-grabber" />;

  if (glyph) {
    return (
      <div
        className={classNames('waypoint-dots', {
          'waypoint-dots--mobile': isMobile && directionsLoaded,
        })}
      >
        {grabber}
        {!last && glyphIcon}
        {last && mapPin}
        {!last && waypointDots}
      </div>
    );
  }

  return null;
};

WaypointIcons.propTypes = WaypointIconsPropTypes;

WaypointIcons.defaultProps = WaypointDefaultProps;

export default WaypointIcons;
